<template>
  <div>
    <div class="bottomBox">
      <div class="button" @click="$back(this)">取消</div>
      <div class="button" @click="myCropper.reset()">还原</div>
      <div class="button" @click="complete">完成</div>

    </div>
    <div class="main">
      <div class="container">
        <div class="img-container">
          <img :src="hg" ref="image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";

export default {
  name: "cut",
  data() {
    return {
      myCropper: null,
      afterImg: '',
      hg: this.$store.state.headImg
    }
  },
  methods: {
    init() {
      this.myCropper = new Cropper(this.$refs.image, {
        viewMode: 1,
        dragMode: 'move',
        initialAspectRatio: 1,
        aspectRatio: 1,
        background: false,
        autoCropArea: 0.6,
        zoomOnWheel: false,
        scalable: false,
        zoomable: false
      })


    },
    sureSava() {
      this.afterImg = this.myCropper.getCroppedCanvas({
        imageSmoothingQuality: 'high'
      }).toDataURL('image/jpeg')


    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },

    complete() {
      this.sureSava()
      if (this.$store.state.SignedIn) {

        // let img = this.$store.state.img

        let img = this.dataURLtoFile(this.afterImg, 'img_file.jpg')


        let forms = new FormData()
        forms.append('img_file', img)

        this.$store.state.imgLock = true
        let queryUpload = this.$encrypt(this.$genQuery({module: 'head_img'}))
        this.$postConfig(this.$store.state.apiUrl + '/member/Upload?qdata=' + queryUpload,forms,{headers:{'Content-Type':'application/x-www-form-urlencoded'}}).then(res => {
        //   this.$post(this.$store.state.apiUrl + '/member/Upload?qdata='+queryUpload,forms).then(res => {
          if (res.status === 0){
            let querySetHeadimg = this.$encrypt(this.$genQuery({ img_requestid:res.data.img_requestid}))
            this.$post(this.$store.state.apiUrl + '/member/set_headimg', {qdata: querySetHeadimg}).then(res => {
              if (res.status === 0) {
                this.$toast(res.msg);

                this.$post(this.$store.state.apiUrl+'/member/getmember',{qdata:this.$encrypt(this.$genQuery({}))}).then(res=>{
                  localStorage.setItem('headImg', res.data.head_img)
                  this.$router.push('/modify')


                }).catch(err=>{
                  console.log(err)
                })
              }else {
                this.$router.push('/modify')

              }

            }).catch(err => {
              console.log(err)
            })
          }

        }).catch(err => {
          console.log(err)
        })

      } else {
        this.$router.push('/userCenter')
        this.$toast('请先登录');
      }
    },

  },
  mounted() {
    this.init()

  }
}
</script>

<style scoped>

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  top: -100px;
  bottom: 0;
  background-color: black;
  overflow: hidden;
}

.container {
  /*position: absolute;*/
  display: flex;
  width: 100%
}

.img-container {
  overflow: hidden;
  max-height: 80%;
}

.bottomBox {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  background-color: black;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  z-index: 10;
}

.button {
  padding: 8px 16px;
}

</style>